import { useState, useCallback, useEffect } from 'react';

export function useShowAction (ref) {
  const [showAction, setShowAction] = useState(false);
  const mouseenter = useCallback(() => setShowAction(true), []);
  const mouseout = useCallback(() => setShowAction(false), []);

  useEffect(() => {
    const element = ref.current;
    if (element) {
      const parent = element.closest('div.ant-row');
      if (parent) {
        parent.addEventListener('mouseover', mouseenter);
        parent.addEventListener('mouseleave', mouseout);
        return () => {
          parent.removeEventListener('mouseover', mouseenter);
          parent.removeEventListener('mouseleave', mouseout);
        };
      }
    }
  }, [ref, mouseenter, mouseout]);

  return { showAction };
}
